import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { BaseControl } from "../../../src/renderer/controls";
import { Rate } from "@h3/antd-vue";
let ETRate = class ETRate extends BaseControl {
    // this.ctrl 组件的控制器. 组件的value 通过 this.ctrl获取
    get allowHalf() {
        return this.options.allowHalf;
    }
    get count() {
        return this.options.count;
    }
    // 那组件配置的属性
    get options() {
        return this.control.options;
    }
    created() {
    }
};
ETRate = tslib_1.__decorate([
    Component({
        name: "Rate",
        components: {
            ARate: Rate,
        }
    })
], ETRate);
export default ETRate;
